"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTable = _styledComponents.default.table(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 100%;\n  border-collapse: separate !important;\n  border-spacing: 0;\n  border-style: hidden;\n\n  & tr:nth-child(even) td {\n    background: #f8f8f9;\n  }\n\n  & th {\n    padding: 0.75rem 0 1rem;\n    text-align: left;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: ", ";\n  }\n\n  & td {\n    padding: 1rem 0.5rem 1rem 0;\n    vertical-align: top;\n    font-size: 0.875rem;\n    border-bottom: 2px solid ", ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  & tr:last-child td {\n    border-bottom: none;\n  }\n"])), function (props) {
  return props.theme.colorLabel;
}, function (props) {
  return props.theme.colorBorder;
});

var StyledColoredText = _styledComponents.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  ", ";\n  ", ";\n  ", ";\n"])), function (p) {
  return p.value === 0 && "color: ".concat(p.theme.colorText);
}, function (p) {
  return p.value > 0 && "color: ".concat(p.theme.colorSuccess);
}, function (p) {
  return p.value < 0 && "color: ".concat(p.theme.colorDanger);
});

var StyledMoreButtonWrapper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-top: 1rem;\n"])));

var StyledEmptyTransactions = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 0.875rem;\n  color: ", ";\n"])), function (p) {
  return p.theme.colorLabel;
});

var WalletButtonsTable = function WalletButtonsTable(_ref) {
  var onError = _ref.onError,
      translations = _ref.translations,
      currencySymbol = _ref.currencySymbol,
      dateLocale = _ref.dateLocale,
      transactionsUpdated = _ref.transactionsUpdated,
      setTransactionsUpdated = _ref.setTransactionsUpdated;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      transactions = _useState4[0],
      setTransactions = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      transactionsTotal = _useState6[0],
      setTransactionsTotal = _useState6[1];

  var _useState7 = (0, _react.useState)(1),
      _useState8 = _slicedToArray(_useState7, 2),
      transactionsPage = _useState8[0],
      setTransactionsPage = _useState8[1];

  var handleMoreButtonClicked = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var res, newTransactions;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.stopPropagation();
              setLoading(true);
              _context.next = 4;
              return _axios.default.get("/wallet/transactions?page=".concat(transactionsPage + 1, "&per_page=10"));

            case 4:
              res = _context.sent;
              newTransactions = transactions.concat(res.data.data);
              setTransactions(newTransactions);
              setTransactionsPage(transactionsPage + 1);
              setLoading(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleMoreButtonClicked(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getTransactions = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _transactionsRes$data, _transactionsRes$data2, _transactionsRes$data3, transactionsRes, response;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log("refreshing transactions");
              _context2.prev = 1;
              _context2.next = 4;
              return _axios.default.get("/wallet/transactions?per_page=10");

            case 4:
              transactionsRes = _context2.sent;
              setTransactions(transactionsRes === null || transactionsRes === void 0 ? void 0 : (_transactionsRes$data = transactionsRes.data) === null || _transactionsRes$data === void 0 ? void 0 : _transactionsRes$data.data);
              setTransactionsTotal(transactionsRes === null || transactionsRes === void 0 ? void 0 : (_transactionsRes$data2 = transactionsRes.data) === null || _transactionsRes$data2 === void 0 ? void 0 : (_transactionsRes$data3 = _transactionsRes$data2.meta) === null || _transactionsRes$data3 === void 0 ? void 0 : _transactionsRes$data3.total);
              _context2.next = 14;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](1);
              response = _context2.t0.response;
              setLoading(false);
              onError(response);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 9]]);
    }));

    return function getTransactions() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    getTransactions();
  }, []);
  (0, _react.useEffect)(function () {
    if (transactionsUpdated) {
      getTransactions();
      setTransactionsUpdated(false);
    }
  }, [transactionsUpdated]);
  var headers = [{
    text: translations.type,
    width: "40%",
    maxWidth: "160px",
    textAlign: "left"
  }, {
    text: translations.amount,
    width: "30%",
    maxWidth: "70px",
    textAlign: "left"
  }, {
    text: translations.balance,
    width: "30%",
    maxWidth: "70px",
    textAlign: "left"
  }];

  var formatTransactionType = function formatTransactionType(type) {
    var words = type.toLowerCase().replace(/_/g, " ").split(" ");
    var friendlyType = "";
    words.forEach(function (word) {
      friendlyType += word.substring(0, 1).toUpperCase() + word.substring(1) + " ";
    });

    switch (type) {
      // case "BET":
      //   friendlyType = "Bet";
      //   break;
      // case "WITHDRAWAL_PENDING":
      //   friendlyType = "Withdrawal Pending";
      //   break;
      // case "REFUND":
      //   friendlyType = "Refund";
      //   break;
      case "UBER_VOUCHER_PROGRAM_CODE":
        friendlyType = "Uber Voucher";
        break;
      // case "PRIZE":
      //   friendlyType = "Prize";
      //   break;
      // case "TICKET":
      //   friendlyType = "Ticket";
      //   break;
      // case "DEPOSIT":
      //   friendlyType = "Deposit";
      //   break;
      // case "ADJUSTMENT":
      //   friendlyType = "ADJUSTMENT";
      //   break;

      default:
    }

    return friendlyType;
  };

  return (transactions === null || transactions === void 0 ? void 0 : transactions.length) > 0 ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StyledTable, null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, headers.map(function (h) {
    return /*#__PURE__*/_react.default.createElement("th", {
      style: {
        width: h.width,
        textAlign: h.textAlign
      }
    }, h.text);
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, transactions.map(function (r, i) {
    return /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
      style: {
        width: headers[0].width,
        maxWidth: headers[0].maxWidth,
        textAlign: headers[0].textAlign
      }
    }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.TitleStack, {
      isSmall: true,
      marginBottom: "0",
      title: formatTransactionType(r.type),
      subtitle: /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.DateTime, {
        format: "DD/MM/YY - h:mm A",
        locale: dateLocale
      }, r.created)
    })), /*#__PURE__*/_react.default.createElement("td", {
      style: {
        width: headers[1].width,
        maxWidth: headers[1].maxWidth,
        textAlign: headers[1].textAlign
      }
    }, r.amount < 0 ? /*#__PURE__*/_react.default.createElement(StyledColoredText, {
      value: r.amount
    }, "-", currencySymbol, (r.amount / 100).toFixed(2).replace("-", "")) : /*#__PURE__*/_react.default.createElement(StyledColoredText, {
      value: r.amount
    }, currencySymbol, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.PenceToPounds, null, r.amount))), /*#__PURE__*/_react.default.createElement("td", {
      style: {
        width: headers[2].width,
        maxWidth: headers[2].maxWidth,
        textAlign: headers[2].textAlign,
        paddingRight: "0.5rem"
      }
    }, r.balance < 0 ? /*#__PURE__*/_react.default.createElement(StyledColoredText, {
      value: r.balance
    }, "-", currencySymbol, (r.balance / 100).toFixed(2).replace("-", "")) : /*#__PURE__*/_react.default.createElement(StyledColoredText, {
      value: r.balance
    }, currencySymbol, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.PenceToPounds, null, r.balance))));
  }))), transactions.length < transactionsTotal - 10 && /*#__PURE__*/_react.default.createElement(StyledMoreButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    size: "sm",
    isLoading: isLoading,
    onClick: handleMoreButtonClicked
  }, "Load more"))) : /*#__PURE__*/_react.default.createElement(StyledEmptyTransactions, null, translations.noTransactionsYet);
};

var _default = WalletButtonsTable;
exports.default = _default;